/**
 * Business type → modules, mirrored from pos-api's single source of truth
 * (`pos-api/src/pos/setup/businessProfile.ts`). `businessProfile.test.ts`
 * there imports this file and fails if the two drift.
 *
 * Frontends ask `isModuleOn(enabledModules, 'kitchen')` — never "is this a
 * restaurant?". `enabledModules` comes from the tenant-config reads
 * (`enabled_modules`); `null` means an existing tenant with EVERY module on.
 */

export const BUSINESS_TYPE_KEYS = ['restaurant', 'retail', 'salon', 'laundry'] as const;
export type BusinessType = (typeof BUSINESS_TYPE_KEYS)[number];

export const MODULE_KEYS = [
  'tables',
  'kitchen',
  'delivery',
  'callCenter',
  'externalOrders',
  'shipping',
  'inventory',
  'appointments',
  'onlineBooking',
  'qrMenu',
  'qrView',
  'barcode',
  'salesStaff',
  'laundry',
] as const;
export type ModuleKey = (typeof MODULE_KEYS)[number];

/** On ONLY when the tenant's list names them — never via null ("every module"). See pos-api. */
export const OPT_IN_MODULES: readonly ModuleKey[] = ['laundry', 'qrView'];

export interface BusinessTypeDef {
  defaultModules: readonly ModuleKey[];
  optionalModules: readonly ModuleKey[];
}

export const BUSINESS_TYPES: Readonly<Record<BusinessType, BusinessTypeDef>> = {
  restaurant: {
    defaultModules: ['tables', 'kitchen', 'delivery', 'qrMenu'],
    optionalModules: ['callCenter', 'externalOrders', 'shipping', 'inventory', 'barcode', 'salesStaff', 'qrView'],
  },
  retail: {
    defaultModules: ['inventory', 'barcode', 'salesStaff'],
    optionalModules: ['delivery', 'shipping', 'externalOrders', 'qrMenu', 'qrView'],
  },
  salon: {
    defaultModules: ['appointments', 'salesStaff'],
    optionalModules: ['onlineBooking', 'inventory', 'barcode'],
  },
  laundry: {
    defaultModules: ['laundry', 'delivery', 'barcode'],
    optionalModules: ['salesStaff', 'inventory'],
  },
};

/** The wire form: an array of module keys, or null for "every module". */
export type EnabledModulesWire = readonly string[] | null | undefined;

export function isModuleOn(enabled: EnabledModulesWire, module: ModuleKey): boolean {
  if (OPT_IN_MODULES.includes(module)) return enabled != null && enabled.includes(module);
  return enabled == null || enabled.includes(module);
}
